import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi.ts";
import type { SearchFilterParams } from "~pages/Persons/PersonListPage/types/searchFilterParams.ts";
import type { PersonResponse } from "~types/person.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

const useFetchPersons = (params: SearchFilterParams, enabled: boolean) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const url = `${sport}/o/${organizationId}/persons?${new URLSearchParams(removeEmptyFields(params) as Record<string, string>).toString()}`;

  return useQuery({
    queryKey: ["persons", sport, organizationId, params],
    enabled: enabled,
    queryFn: async () => request<PersonResponse>(url).then((response) => transformListResponse(response)),
  });
};

export default useFetchPersons;
